import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { XMarkIcon } from '@heroicons/react/24/outline';
//import { Test } from './Search.styles';

const Search = ({search, value, colour}) => {
  const [ searchValue, setSearchValue ] = useState(value || '');
  const [filterTimeout, setFilterTimeout] = React.useState(0);

	function handleChange(value) {
		setSearchValue(value);
    if (filterTimeout) clearTimeout(filterTimeout);
		setFilterTimeout(setTimeout(() => {
			search(value);
		}, 500));
  }

  useEffect(() => {
    if (value && value.length > 0) {
      setSearchValue(value);
    } else {
      setSearchValue('');
    }
  }, [value])
  
  return (
  <div className="flex">
    <div className="mt-2 relative rounded-md shadow-md w-full" style={{maxHeight: 34}}>
      <input id="search" className="form-input block bg-white w-full focus:outline-none focus:shadow-outline border border-gray-100 rounded-lg py-[5px] px-4 appearance-none pl-3 pr-12" value={searchValue} onChange={(e) => {
        handleChange(e.target.value);
      }}/>
      <div className={`absolute inset-y-0 right-0 px-2 h-[36px] flex items-center cursor-pointer bg-${colour ? colour : 'blue'}-700 rounded-r-lg z-10`}>
        {searchValue !== '' ? 
           <div onClick={() => handleChange('')} className='w-6 h-6 z-10'><XMarkIcon className='h-6 w-6 text-white cursor-pointer' /></div>
         : <span className="text-white sm:text-sm sm:leading-5">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path className="heroicon-ui" style={{fill: '#FFF'}} d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"/></svg>
          </span>}
      </div>
    </div>
  </div>
)};

Search.propTypes = {
  initialValue: PropTypes.string,
};

Search.defaultProps = {
  initialValue: '',
};

export default Search;
